/** Known setting keys used by the app. */
export const SETTING_KEYS = {
    aiSystemPrompt: 'ai_blog_translation_system_prompt',
    aiUserPrompt: 'ai_blog_translation_user_prompt',
};
//# sourceMappingURL=setting.js.map